export enum EContactSelectorSort {
	/** Trié par `lastName` pour les contacts et par `name` pour les groupes. */
	alphabetical = "alphabetical",
	/** Trié par participants pré-sélectionnés puis par ordre alphabétique (`lastName` pour les contacts et par `name` pour les groupes). */
	byPreSelectedParticipants = "byPreSelectedParticipants"
}
